module.exports = __webpack_public_path__ + "static/media/fondo-perfil-azul.d86860d5.png";